var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 300,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 6.82666 6.82666",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_552518568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_552520200",
    d: "m.698205 1.65999c-.114854 0-.208287.0934252-.208287.208283l.00000787 3.72089c0 .0555354.0216693.107917.0610157.147256.0392283.0392205.0914724.0609016.147012.0609016.00014173-.00000394.00012205 0 .00024803 0l5.43015-.00000394c.114854 0 .208374-.0934173.208374-.208276l.00001575-3.72078c0-.114854-.0935591-.208276-.208413-.208276l-5.43012-.00000394zm-.00024803 4.27765c-.0930394 0-.18039-.0362953-.246283-.102067-.065752-.0657756-.102071-.153343-.102071-.246402l.00000787-3.7209c0-.192209.156386-.348587.348591-.348587l5.43015-.00000787c.192299 0 .348689.156398.348689.348598l.00001575 3.72077c0 .192209-.156409.348598-.348728.348598l-5.43012-.00000394s-.00012992.00000394-.00024803 0z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552520392",
    d: "m.982724 2.12563c-.0149646 0-.0271614.012185-.0271614.0271654l.00000394 3.15171c0 .0149882.0121772.0271693.0271575.0271693h3.94722c.0149646 0 .0272598-.0121811.0272598-.0271614l.00000787-3.15173c0-.0149764-.012311-.0271496-.0272913-.0271496l-3.9472-.00000787zm3.94722 3.34636h-3.94722c-.0922992 0-.167476-.0751496-.167476-.167476l.00000394-3.15173c0-.092315.0751496-.167465.167472-.167465l3.94722-.00000787c.092437 0 .167453.0751575.167453.16748l.00001968 3.15171c0 .0923228-.0750512.167484-.167472.167484z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552520056",
    d: "m1.40674 6.30462h-.54287c-.100244 0-.18187-.0816024-.18187-.181843l.00001181-.255173c0-.0387402.0314134-.0701575.0701496-.0701575.0387323 0 .0701575.0314252.0701575.0701575l.00000787.255169c0 .0228976.018626.0415394.0415236.0415394l.54289-.00000787c.0228858 0 .0415079-.018626.0415079-.0415276l.00001181-.255173c0-.0387402.0312953-.0701575.0700276-.0701575.0388819 0 .0701575.0314252.0701575.0701575l.00001968.255169c0 .100244-.0815079.18185-.181724.181846z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519576",
    d: "m5.9628 6.30462h-.542843c-.100248 0-.18187-.0816024-.18187-.181843l.00000787-.255173c0-.0387402.0314173-.0701575.0701496-.0701575s.0701535.0314252.0701535.0701575l.00001181.255169c0 .0228976.018626.0415394.0415236.0415394l.542866-.00000787c.0229094 0 .0415354-.018626.0415354-.0415276l.00001181-.255173c0-.0387402.0314134-.0701575.0701457-.0701575s.0701575.0314252.0701575.0701575l.00001181.255169c0 .100244-.0816181.18185-.181862.181846z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519408",
    d: "m5.95805 3.61478h-.498528c-.0387205 0-.0701654-.0314213-.0701654-.0701535.00000787-.0387402.0314252-.0701575.0701575-.0701575l.498535-.00000394c.038752 0 .0701496.0314252.0701496.0701614.00000787.0387165-.0314213.0701575-.0701496.0701535z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519648",
    d: "m5.95805 3.25448h-.498528c-.0387205 0-.0701654-.0314094-.0701654-.0701417.00000787-.0388583.0314252-.0701575.0701575-.0701575h.498535c.038752 0 .0701496.0312992.0701496.0701575.00000787.0387244-.0314213.0701575-.0701496.0701417z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519264",
    d: "m5.9013 4.24497h.00011024zm-.371508 0v1.08671h.358102v-1.08671zm-.0133701 1.22703c-.0699409 0-.126941-.0568819-.126941-.126917v-1.11351c0-.0700354.057-.126909.126917-.126909l.384902-.00000787c.0700472 0 .126902.0568898.126902.126921l.00000787 1.11349c0 .0699252-.0568858.126929-.126921.126929h-.384866z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519120",
    d: "m5.70886 2.12551c-.0987953 0-.179185.0804016-.179185.179181.00000787.0989016.0803898.179287.179169.179287.0987835-.00001181.179165-.0803858.179165-.179287.00002756-.0987874-.0803858-.179169-.17915-.179181zm0 .498772c-.176134 0-.3195-.143346-.3195-.319591.00000787-.176126.143358-.319484.319484-.319484.17626-.00001181.31948.143358.31948.319484.00002362.176236-.143236.319602-.319465.319591z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519528",
    d: "m2.81024 3.45156v.545295l.45128-.292071zm-.0701575.744323c-.0114567 0-.0230354-.00279528-.0335079-.00851969-.0225079-.012185-.0366654-.035937-.0366654-.0616339l.00001575-.794028c0-.0248386.0132598-.0479803.0346969-.0605276.0215669-.0125472.0481142-.0127874.0697953-.0006063l.657236.368799c.0214567.0120591.0349567.0343583.0358071.0589646.00075197.0245945-.0114488.0477441-.0320315.0611457l-.657228.425201c-.011563.0074252-.0247323.0112087-.0381181.0112047z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519720",
    d: "m2.95639 2.95937c-.424232 0-.769299.345185-.769299.769295.00000787.424228.345063.769295.769295.769295.42413-.00001181.769295-.345063.769295-.769295 0-.424114-.345185-.769291-.769291-.769295zm0 1.67889c-.501567 0-.909614-.408024-.909614-.909598.00000787-.501587.408035-.909606.90961-.909606.501575-.00000394.909606.408028.909606.909606.00000394.501567-.408031.909606-.909602.909598z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519504",
    d: "m3.36591 1.65999c-.0388583 0-.070185-.0314213-.070185-.0701496 0-.187094-.152248-.33922-.339335-.33922-.187063 0-.339217.15213-.339217.33922.00002756.0387244-.0314252.0701535-.0701535.0701535-.0387283-.00000394-.0701575-.0314252-.0701575-.0701535.00002362-.264441.215098-.479531.479528-.479531.264437 0 .479654.215098.479654.479531.00002362.0387244-.0314252.0701535-.0701339.0701496z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519696",
    d: "m2.66699 1.37047c-.0185 0-.0365472-.0074252-.0497008-.0205787l-.707886-.708154c-.0274094-.0274055-.0274252-.0717362-.00001968-.0991417.0274213-.0274173.0718622-.0274016.0992638 0l.706575.706811c.0135394.0127835.0219173.030937.0219173.0509134.00000787.0387283-.0314173.0701575-.0701496.0701496z",
    fill: "#c72538",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_552519288",
    d: "m3.24593 1.37047c-.0179252 0-.0358307-.00681496-.0495945-.0205787-.0273898-.0274094-.0274055-.0717402 0-.0991457l.707917-.708161c.0272717-.0274055.0717283-.0273898.0991339.00001181.0274252.0273937.0274055.0717441 0 .0991457l-.707776.708146c-.0137559.0137559-.0316772.0205906-.0496811.0205827z",
    fill: "#c72538",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeries);
export default __webpack_public_path__ + "static/media/series.5a96f667f9ef76813d9a6e1a55d6a11c.svg";
export { ForwardRef as ReactComponent };